import { Palette, Sizes } from "./palette";

export const MarkdownBoxStyles = {
    color: Palette.textColorPrimary,
    fontSize: Sizes.textPrimary,
    "& h1": {
        marginTop: "2em",
        marginBottom: "0.5em",
        fontSize: Sizes.pageTitle,
        color: Palette.textColorPrimary
    },
    "& h2": {
        marginTop: "1em",
        marginBottom: "0.5em",
        fontSize: Sizes.pageSecondTitle,
        color: Palette.textColorPrimary
    },
    "& h3": {
        marginTop: "1em",
        marginBottom: "0.5em",
        fontSize: Sizes.pageThirdTitle,
        color: Palette.textColorPrimary
    },
    "& code.language-bash": {
        padding: "10px",
        borderRadius: "5px",
        background: Palette.backgroundColorPrimary
    },
    "& code": {
        padding: "10px",
        borderRadius: "5px",
        background: Palette.backgroundColorPrimary,
        display: "block"
    },
    "& table": {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "1em",
        marginBottom: "1em"
    },
    "& th": {
        backgroundColor: Palette.backgroundColorPrimary,
        color: Palette.textColorPrimary,
        fontWeight: 600,
        padding: "10px 12px",
        textAlign: "left",
        borderBottom: `2px solid ${Palette.borderColorPrimary}`
    },
    "& td": {
        padding: "10px 12px",
        borderBottom: `1px solid ${Palette.borderColorPrimary}`
    },
    "& tr:hover": {
        backgroundColor: Palette.backgroundColorPrimary
    },
    "& > *:first-child": {
        marginTop: 0
    },
    "& > *:last-child": {
        marginBottom: 0
    }
}